import { render } from "./IconEvent.vue?vue&type=template&id=1702f47e"
import script from "./IconEvent.vue?vue&type=script&lang=js"
export * from "./IconEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__